import common from './common.json';
import flashcards from './flashcards.json';
import questions from './questions.json';

const locales = { common, flashcards, questions };

export default locales;
